
    var locales = require('../../../../locale-loader/runtime.js');
    module.exports = locales.getLocale({"de":{},"en":{},"es":{},"fr":{},"it":{},"ja":{},"ko":{},"pt":{},"ru":{},"zh":{}});
  